module.exports = __webpack_public_path__ + "img/lots-icon.ee499b09.svg";